/* global window */

var lodash;

if (typeof require === "function") {
  try {
    lodash = require("lodash");
  } catch (e) {}
}

if (!lodash) {
  lodash = window._;
}

module.exports = lodash;



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/lodash.js
// module id = 959
// module chunks = 0